<div class="ai-expanded-overlay" *ngIf="expanded" (click)="$event.target === $event.currentTarget && (expanded = false)"></div>

<div class="ai-editor-wrap" [class.ai-editor-expanded]="expanded">

  <div class="ai-expand-header" *ngIf="expanded">
    <span class="ai-expand-title">AI Editors</span>
    <div class="ai-header-actions">
      <button class="ai-transfer-btn" *ngIf="compareTargets.length > 0" (click)="toggleCompare()"
              title="Compare AI with another crew member">
        {{ showCompare ? 'Close Compare' : '+ Add section to right' }}
      </button>
      <button class="ai-expand-btn ai-minimize-btn" (click)="expanded = false" title="Minimize">X Minimize</button>
    </div>
  </div>

  <div class="ai-top-bar" *ngIf="!expanded">
    <button class="ai-expand-btn" (click)="expanded = true" title="Expand AI editor">⊞</button>
  </div>

  <div class="ai-content-row">

    <!-- Main pane -->
    <div class="ai-main-panel">
      <app-ai-pane
        [rules]="rules"
        [conditionTypes]="conditionTypes"
        [actionTypes]="actionTypes"
        [itemsByIndex]="itemsByIndex"
        [saving]="saving"
        [error]="error"
        [emptyMessage]="emptyMessage"
        [targetType]="targetType"
        [targetId]="targetId"
        [targetName]="targetName"
        [targetSpriteId]="targetSpriteId"
        [expanded]="expanded"
        [initialConditionId]="initialConditionId"
        [initialActionId]="initialActionId"
        [userId]="userId"
        [allianceId]="allianceId"
        [userName]="userName"
        (addRule)="addRule.emit($event)"
        (deleteRule)="deleteRule.emit($event)"
        (moveRule)="moveRule.emit($event)"
        (editRule)="editRule.emit($event)"
        (importRules)="importRules.emit($event)"
        (deleteAllRules)="deleteAllRules.emit()">
      </app-ai-pane>
    </div>

    <!-- Compare / right panel (fullscreen only) -->
    <div class="ai-compare-panel" *ngIf="expanded && showCompare">

      <!-- Target picker -->
      <ng-container *ngIf="!selectedCompare">
        <div class="ai-compare-search-row">
          <input class="ai-combo-input ai-compare-search-input"
                 [(ngModel)]="compareSearch"
                 placeholder="Search crew..."
                 autocomplete="off">
        </div>
        <div class="ai-compare-crew-list">
          <div class="ai-compare-crew-item"
               *ngFor="let t of filteredCompareTargets()"
               (click)="selectCompareTarget(t)">
            <span class="ai-compare-crew-name">{{ t.name }}</span>
            <span class="ai-compare-crew-count">{{ t.rules.length }} AI line{{ t.rules.length !== 1 ? 's' : '' }}</span>
          </div>
          <div class="ai-compare-empty" *ngIf="filteredCompareTargets().length === 0">No crew found</div>
        </div>
      </ng-container>

      <!-- Selected compare target pane -->
      <ng-container *ngIf="selectedCompare">
        <div class="ai-compare-selected-header">
          <button class="ai-transfer-btn" (click)="clearCompareSelection()">← Back</button>
        </div>
        <app-ai-pane
          [rules]="selectedCompare.rules"
          [conditionTypes]="conditionTypes"
          [actionTypes]="actionTypes"
          [saving]="compareSaving"
          [error]="compareError"
          [emptyMessage]="'No AI rules set for this crew.'"
          [targetType]="targetType"
          [targetId]="selectedCompare.id"
          [targetName]="selectedCompare.name"
          [targetSpriteId]="selectedCompare.spriteId"
          [expanded]="expanded"
          [userId]="userId"
          [allianceId]="allianceId"
          (addRule)="onCmpAddRule($event)"
          (deleteRule)="onCmpDeleteRule($event)"
          (moveRule)="onCmpMoveRule($event)"
          (editRule)="onCmpEditRule($event)"
          (importRules)="onCmpImportRules($event)"
          (deleteAllRules)="onCmpDeleteAllRules()"
          (rulesChanged)="onCmpRulesChanged($event)">
        </app-ai-pane>
      </ng-container>

    </div><!-- /.ai-compare-panel -->

  </div><!-- /.ai-content-row -->

</div><!-- /.ai-editor-wrap -->
